import { getCSSVar } from "shared/lib/utils"

if (typeof window !== 'undefined' && typeof window.globalHighchartsOptions === 'undefined') {
  window.globalHighchartsOptions = {
    lang: {
      thousandsSep: ",",
    },
    chart: {
      style: {
        fontFamily: getCSSVar('avenir-font-family'),
      },
    },
  }
}